// extracted by mini-css-extract-plugin
export default {"container":"RendingLayout_container__jPSkB","wrapper":"RendingLayout_wrapper__1sDbE"};